import { render, staticRenderFns } from "./SalaryEmployee.vue?vue&type=template&id=331ae6bf&scoped=true"
import script from "./SalaryEmployee.vue?vue&type=script&lang=js"
export * from "./SalaryEmployee.vue?vue&type=script&lang=js"
import style0 from "./SalaryEmployee.vue?vue&type=style&index=0&id=331ae6bf&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331ae6bf",
  null
  
)

export default component.exports